import { render, staticRenderFns } from "./stock-batch-table.vue?vue&type=template&id=358cdd50&"
import script from "./stock-batch-table.vue?vue&type=script&lang=js&"
export * from "./stock-batch-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports